/* ==========================================================================
   CAND / PDP — Auto-scroll da faixa de miniaturas no mobile

   O tema (theme.js > slideshow.childNavGoTo) decide o eixo de rolagem das
   miniaturas na inicializacao, a partir de data-position="beside" -> eixo Y.
   Como no mobile a faixa e horizontal (ver pdp.css), a
   miniatura ativa nunca entrava em vista ao deslizar a foto principal.

   Aqui observamos a classe .is-active que o tema aplica na miniatura atual
   e centralizamos ela no eixo X, sem tocar em theme.js.

   Par: assets/pdp.css
   Carregado em: layout/theme.liquid
   ========================================================================== */

(function () {
  'use strict';

  var MOBILE_MAX = 768;
  var SCROLLER = '.product__thumbs--scroller';
  var ACTIVE_THUMB = '.product__thumb.is-active';

  function centerThumb(scroller, thumb) {
    if (window.innerWidth > MOBILE_MAX) return;

    var item = thumb.closest('.product__thumb-item') || thumb;
    var itemRect = item.getBoundingClientRect();
    var scrollerRect = scroller.getBoundingClientRect();

    // Deslocamento necessario para centralizar a miniatura na faixa visivel.
    // Usa getBoundingClientRect (e nao offsetLeft) para nao depender de qual
    // elemento e o offsetParent, que muda entre os breakpoints.
    var delta =
      itemRect.left - scrollerRect.left - (scroller.clientWidth - itemRect.width) / 2;

    scroller.scrollLeft += delta;
  }

  function centerActive(scroller) {
    var thumb = scroller.querySelector(ACTIVE_THUMB);
    if (thumb) centerThumb(scroller, thumb);
  }

  function centerAll() {
    document.querySelectorAll(SCROLLER).forEach(centerActive);
  }

  // Um unico observer no documento cobre tambem galerias injetadas depois
  // (quick shop, recarga de secao no editor de temas).
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var el = mutations[i].target;

      if (el.nodeType !== 1 || !el.matches || !el.matches(ACTIVE_THUMB)) continue;

      var scroller = el.closest(SCROLLER);
      if (scroller) centerThumb(scroller, el);
      return;
    }
  });

  function start() {
    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    centerAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Recentraliza ao girar o aparelho / cruzar o breakpoint
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(centerAll, 150);
  });
})();
